import { AppShell, useMantineTheme, Paper } from "@mantine/core";
import React, { useState, memo } from "react";
import { Outlet } from "react-router-dom";
import TheHeader from "./TheHeader";
import TheSidebar from "./TheSidebar";

const TheLayout = () => {
  const theme = useMantineTheme();
  const [opened, setOpened] = useState(false);
  return (
    <AppShell
      styles={{
        main: {
          background:
            theme.colorScheme === "dark"
              ? theme.colors.dark[8]
              : theme.colors.gray[0],
        },
      }}
      navbarOffsetBreakpoint="sm"
      asideOffsetBreakpoint="sm"
      navbar={<TheSidebar opened={opened} />}
      header={<TheHeader opened setOpened={setOpened} />}
    >
      <Paper sx={{ height: "100%" }} p="md">
        <Outlet />
      </Paper>
    </AppShell>
  );
};

export default memo(TheLayout);
